import { useReveal } from "@/hooks/useReveal";

const TRUST = ["USDA Organic", "EU Organic", "HACCP", "INVIMA"];

export default function Hero() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section
      id="top"
      className="relative min-h-[600px] md:min-h-[720px] flex items-center"
    >
      <div className="absolute inset-0">
        <img
          src="https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/0f570fc6-8042-4510-9692-fc3371f3250e_compressed_mesa-baja-all-products.webp"
          alt="Branded kraft pouches of organic cane sugar on a health-food store shelf"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative w-full max-w-[1200px] mx-auto px-4 md:px-6 pt-28 md:pt-32 pb-14">
        <div ref={ref} className="reveal w-full lg:max-w-[60%]">
          <h1 className="text-white font-serif text-3xl md:text-5xl font-semibold leading-tight md:leading-[1.15]">
            A certified organic range nobody else in your territory is carrying
            yet
          </h1>

          <p className="mt-6 text-cream/90 text-[17px] md:text-lg leading-relaxed max-w-2xl">
            Mesa Baja is a family-run producer in Colombia&apos;s coffee region.
            Organic unrefined whole cane sugar and pure cocoa powder, Ecocert
            certified for USDA and EU Organic, packed retail-ready and offered
            under territory exclusivity. We ship to Germany, Australia, Chile
            and Romania, and South Africa is open.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <a
              href="#quote"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md bg-brand text-white text-base font-semibold hover:bg-brand-dark transition-colors"
            >
              Check territory availability
            </a>
            <a
              href="#trade"
              className="whitespace-nowrap inline-flex items-center justify-center px-6 py-3.5 rounded-md border border-white/60 text-white text-base font-semibold hover:bg-white/10 transition-colors"
            >
              Minimum first order
            </a>
          </div>

          <div className="mt-9 inline-flex flex-wrap items-center gap-x-6 gap-y-2 bg-white/10 backdrop-blur border border-white/15 rounded-lg px-5 py-3">
            {TRUST.map((item) => (
              <span
                key={item}
                className="flex items-center gap-2 text-cream/90 text-sm whitespace-nowrap"
              >
                <i className="ri-check-line text-brand"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}